export type MerryButtonHierarchy =
  | "level0"
  | "level1"
  | "level2"
  | "level3"
  | "navigation";

export type MerryButtonSize = 34 | 48;
export type MerryButtonInteractionState = "default" | "hovered" | "pressed";
export type MerryButtonContentVariant = "text" | "iconOnly";

type HierarchyNodeMap = Record<MerryButtonHierarchy, string>;
type SizeNodeMap = Record<MerryButtonSize, HierarchyNodeMap>;
type ContentNodeMap = Record<MerryButtonContentVariant, SizeNodeMap>;

export const merryButtonFigmaNodeIds = {
  default: {
    text: {
      34: {
        level0: "300:31086",
        level1: "303:3378",
        level2: "300:31272",
        level3: "303:3383",
        navigation: "300:31414",
      },
      48: {
        level0: "299:31101",
        level1: "303:3368",
        level2: "300:31264",
        level3: "303:3373",
        navigation: "300:31410",
      },
    },
    iconOnly: {
      34: {
        level0: "303:3403",
        level1: "303:3408",
        level2: "300:31268",
        level3: "303:3413",
        navigation: "300:31422",
      },
      48: {
        level0: "303:3388",
        level1: "303:3393",
        level2: "300:31280",
        level3: "303:3398",
        navigation: "300:31418",
      },
    },
  },
  hovered: {
    text: {
      34: {
        level0: "303:3433",
        level1: "303:3438",
        level2: "300:31296",
        level3: "303:3443",
        navigation: "300:31430",
      },
      48: {
        level0: "303:3418",
        level1: "303:3423",
        level2: "300:31288",
        level3: "303:3428",
        navigation: "300:31426",
      },
    },
    iconOnly: {
      34: {
        level0: "303:3463",
        level1: "303:3468",
        level2: "300:31304",
        level3: "303:3473",
        navigation: "300:31438",
      },
      48: {
        level0: "303:3448",
        level1: "303:3453",
        level2: "300:31300",
        level3: "303:3458",
        navigation: "300:31434",
      },
    },
  },
  pressed: {
    text: {
      34: {
        level0: "303:3493",
        level1: "303:3498",
        level2: "300:31284",
        level3: "303:3503",
        navigation: "300:31446",
      },
      48: {
        level0: "303:3478",
        level1: "303:3483",
        level2: "300:31308",
        level3: "303:3488",
        navigation: "300:31442",
      },
    },
    iconOnly: {
      34: {
        level0: "303:3523",
        level1: "303:3528",
        level2: "300:31276",
        level3: "303:3533",
        navigation: "300:31454",
      },
      48: {
        level0: "303:3508",
        level1: "303:3513",
        level2: "300:31292",
        level3: "303:3518",
        navigation: "300:31450",
      },
    },
  },
} as const satisfies Record<MerryButtonInteractionState, ContentNodeMap>;

export function getMerryButtonFigmaNodeId(
  state: MerryButtonInteractionState,
  content: MerryButtonContentVariant,
  size: MerryButtonSize,
  hierarchy: MerryButtonHierarchy,
) {
  return merryButtonFigmaNodeIds[state][content][size][hierarchy];
}
